import { useContext, useEffect, useState } from 'react';
import { MODALS } from '../../../../constants';
import { Context } from '../../../../context/AppContext';

/**
 * The legacy search bar modal's state was managed in AppContext. This hook is used to transform the legacy state management
 * to the new modal state management in SearchContext.
 */
const useModal = () => {
  const [modal, setModalLocal] = useState({ show: false });
  const {
    modal: { modals, showModal, hideModal },
  } = useContext(Context);
  const modalStateInAppContext = modals[MODALS.SEARCH_AUTOSUGGEST];

  /** When modal state is changed in AppContext, save it to showModal */
  useEffect(() => {
    setModalLocal(modalStateInAppContext);
  }, [modalStateInAppContext]);

  /** Change the modal state in AppContext */
  const setModal = (status, data) => {
    if (status) {
      showModal(MODALS.SEARCH_AUTOSUGGEST, data);
    } else {
      hideModal(MODALS.SEARCH_AUTOSUGGEST);
    }
  };

  return [modal, setModal];
};

export default useModal;
